import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const dict = {
  en: {
    app_name: "Rana Associates",
    tagline: "Pan Rajasthan Property Valuation Platform",
    admin: "Admin",
    bank: "Bank / NBFC",
    field: "Field Executive",
    office: "Office Staff",
    manager: "Manager",
    login: "Login",
    logout: "Logout",
    email: "Email",
    pass_label: "Password",
    sign_in: "Sign In",
    dashboard: "Dashboard",
    banks: "Banks",
    executives: "Field Executives",
    managers: "Managers",
    security: "Security",
    notifications: "Notifications",
    staff: "Office Staff",
    leads: "Leads",
    my_leads: "My Leads",
    visits: "Visits",
    loan_leads: "Loan Leads",
    reports: "Reports",
    courses: "Training",
    profile: "Profile",
    earnings: "Earnings",
    total_leads: "Total Leads",
    pending: "Pending",
    in_progress: "In Progress",
    visited: "Visited",
    submitted: "Submitted",
    add_lead: "Add Lead",
    add_bank: "Add Bank",
    add_executive: "Add Executive",
    add_staff: "Add Staff",
    add_course: "Add Course",
    assign: "Assign",
    submit: "Submit",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    customer_name: "Customer Name",
    property_address: "Property Address",
    location: "Location",
    tat: "TAT (hours)",
    branch: "Branch",
    valuation_type: "Valuation Type",
    pre_visit: "Pre-Sanction",
    post_visit: "Post-Sanction",
    notes: "Notes",
    status: "Status",
    actions: "Actions",
    upload_photos: "Upload Photos",
    upload_docs: "Upload Documents",
    boundary_dimensions: "Boundary Dimensions",
    north: "North",
    south: "South",
    east: "East",
    west: "West",
    plot_length: "Plot Length (ft)",
    plot_width: "Plot Width (ft)",
    built_up: "Built-up Area (sqft)",
    year_construction: "Year of Construction",
    bylaws_notes: "Building Bylaws Notes",
    valuation_amount: "Valuation Amount (₹)",
    submit_visit: "Submit Visit",
    portal_link: "Bank Submission Portal",
    submit_to_portal: "Submit to Bank Portal",
    training_courses: "Training & Free Courses",
    landing_hero: "Trusted Property Valuation Operations across Rajasthan",
    landing_sub:
      "One platform for banks, NBFCs, office staff and field executives. Assign, visit, submit — with a full audit trail.",
    choose_role: "Choose your role to sign in",
    daily_earnings: "Daily Earnings",
    monthly_earnings: "Monthly Earnings",
    grand_total: "Grand Total",
    kyc: "KYC",
    working_agreement: "Working Agreement",
    home_address: "Home Address",
    working_location: "Working Location",
    working_radius: "Working Radius (km)",
    rate_per_report: "Rate per Report (₹)",
    property_paper: "Property Paper Ref",
    logged_in_as: "Logged in as",
    welcome_back: "Welcome back",
  },
  hi: {
    app_name: "राणा एसोसिएट्स",
    tagline: "पैन राजस्थान प्रॉपर्टी वैल्यूएशन प्लेटफ़ॉर्म",
    admin: "एडमिन",
    bank: "बैंक / एनबीएफसी",
    field: "फ़ील्ड एग्ज़ीक्यूटिव",
    office: "ऑफ़िस स्टाफ़",
    manager: "मैनेजर",
    login: "लॉगिन",
    logout: "लॉगआउट",
    email: "ईमेल",
    pass_label: "पासवर्ड",
    sign_in: "साइन इन करें",
    dashboard: "डैशबोर्ड",
    banks: "बैंक",
    executives: "फ़ील्ड एग्ज़ीक्यूटिव",
    managers: "मैनेजर",
    security: "सुरक्षा",
    notifications: "सूचनाएं",
    staff: "ऑफ़िस स्टाफ़",
    leads: "लीड्स",
    my_leads: "मेरी लीड्स",
    visits: "विज़िट",
    loan_leads: "लोन लीड्स",
    reports: "रिपोर्ट्स",
    courses: "ट्रेनिंग",
    profile: "प्रोफ़ाइल",
    earnings: "कमाई",
    total_leads: "कुल लीड्स",
    pending: "लंबित",
    in_progress: "प्रगति पर",
    visited: "विज़िट पूरी",
    submitted: "जमा",
    add_lead: "लीड जोड़ें",
    add_bank: "बैंक जोड़ें",
    add_executive: "एग्ज़ीक्यूटिव जोड़ें",
    add_staff: "स्टाफ़ जोड़ें",
    add_course: "कोर्स जोड़ें",
    assign: "असाइन करें",
    submit: "जमा करें",
    save: "सेव",
    cancel: "रद्द",
    delete: "हटाएँ",
    edit: "एडिट",
    view: "देखें",
    customer_name: "ग्राहक का नाम",
    property_address: "संपत्ति पता",
    location: "स्थान",
    tat: "TAT (घंटे)",
    branch: "शाखा",
    valuation_type: "वैल्यूएशन प्रकार",
    pre_visit: "प्री-सैंक्शन",
    post_visit: "पोस्ट-सैंक्शन",
    notes: "नोट्स",
    status: "स्थिति",
    actions: "क्रियाएँ",
    upload_photos: "फ़ोटो अपलोड",
    upload_docs: "दस्तावेज़ अपलोड",
    boundary_dimensions: "सीमा माप",
    north: "उत्तर",
    south: "दक्षिण",
    east: "पूर्व",
    west: "पश्चिम",
    plot_length: "प्लॉट लंबाई (फ़ीट)",
    plot_width: "प्लॉट चौड़ाई (फ़ीट)",
    built_up: "बिल्ट-अप क्षेत्र (वर्ग फ़ीट)",
    year_construction: "निर्माण वर्ष",
    bylaws_notes: "बिल्डिंग बायलॉज़ नोट्स",
    valuation_amount: "वैल्यूएशन राशि (₹)",
    submit_visit: "विज़िट जमा करें",
    portal_link: "बैंक सबमिशन पोर्टल",
    submit_to_portal: "बैंक पोर्टल पर जमा करें",
    training_courses: "ट्रेनिंग एवं फ़्री कोर्स",
    landing_hero: "पूरे राजस्थान में विश्वसनीय प्रॉपर्टी वैल्यूएशन ऑपरेशन्स",
    landing_sub:
      "बैंक, एनबीएफसी, ऑफ़िस स्टाफ़ और फ़ील्ड एग्ज़ीक्यूटिव — एक ही प्लेटफ़ॉर्म पर।",
    choose_role: "साइन इन के लिए भूमिका चुनें",
    daily_earnings: "दैनिक कमाई",
    monthly_earnings: "मासिक कमाई",
    grand_total: "कुल योग",
    kyc: "केवाईसी",
    working_agreement: "वर्किंग एग्रीमेंट",
    home_address: "घर का पता",
    working_location: "कार्य स्थान",
    working_radius: "कार्य त्रिज्या (कि.मी)",
    rate_per_report: "प्रति रिपोर्ट दर (₹)",
    property_paper: "संपत्ति पेपर रेफ़",
    logged_in_as: "लॉगिन",
    welcome_back: "वापसी पर स्वागत है",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("rv_lang") || "en");
  useEffect(() => {
    localStorage.setItem("rv_lang", lang);
  }, [lang]);
  const t = useCallback((key) => dict[lang][key] || dict.en[key] || key, [lang]);
  const toggle = useCallback(() => setLang((l) => (l === "en" ? "hi" : "en")), []);
  const value = useMemo(() => ({ lang, setLang, toggle, t }), [lang, toggle, t]);
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
